// extracted by mini-css-extract-plugin
export default {"disabled":"_35074da6e811a675763cffb384c26dc2"};